module.exports = "<div  *ngFor=\"let r of results\" style=\"margin-bottom: 5px\">\n        <a target=\"_blank\" [href]=\"r.directUrl\">{{r.formName}}</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/forms.html
// module id = ./src/app/components/forms/forms.html
// module chunks = main